// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Error$LiteracyplanetClientErrors from "@literacyplanet/client-errors/src/Error.res.mjs";
import * as CobraContainer$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/CobraContainer.res.mjs";
import * as BackgroundChanger$LiteracyplanetClientSxEntry from "../BackgroundChanger.res.mjs";

var xprops = {
  extraVocals: [
    {
      name: "intro01",
      audio: {
        source: "https://intrepica-support-dir.s3.amazonaws.com/cobra2-placeholder-assets/en-temp/jwt/jwt-intro-01.mp3"
      }
    },
    {
      name: "intro02",
      audio: {
        source: "https://intrepica-support-dir.s3.amazonaws.com/cobra2-placeholder-assets/en-temp/jwt/jwt-intro-02.mp3"
      }
    },
    {
      name: "intro03",
      audio: {
        source: "https://intrepica-support-dir.s3.amazonaws.com/cobra2-placeholder-assets/en-temp/jwt/jwt-intro-03.mp3"
      }
    },
    {
      name: "intro04",
      audio: {
        source: "https://intrepica-support-dir.s3.amazonaws.com/cobra2-placeholder-assets/en-temp/jwt/jwt-intro-04.mp3"
      }
    },
    {
      name: "intro05",
      audio: {
        source: "https://intrepica-support-dir.s3.amazonaws.com/cobra2-placeholder-assets/en-temp/jwt/jwt-intro-05.mp3"
      }
    },
    {
      name: "intro06",
      audio: {
        source: "https://intrepica-support-dir.s3.amazonaws.com/cobra2-placeholder-assets/en-temp/jwt/jwt-intro-06.mp3"
      }
    },
    {
      name: "intro07",
      audio: {
        source: "https://intrepica-support-dir.s3.amazonaws.com/cobra2-placeholder-assets/en-temp/jwt/jwt-intro-07.mp3"
      }
    },
    {
      name: "intro08",
      audio: {
        source: "https://intrepica-support-dir.s3.amazonaws.com/cobra2-placeholder-assets/en-temp/jwt/jwt-intro-08.mp3"
      }
    }
  ]
};

function StoryverseIntro(props) {
  var match = Error$LiteracyplanetClientErrors.Consumer.use();
  var onSetError = match.onSetError;
  var match$1 = BackgroundChanger$LiteracyplanetClientSxEntry.use();
  var setBackground = match$1[1];
  var ready = function (c) {
    setBackground(function (param) {
          return c.backgroundColor;
        });
  };
  var onDispatch_onExit = props.onExit;
  var onDispatch_onFailed = function (err) {
    onSetError(Error$LiteracyplanetClientErrors.JsInterop.makeError("JourneyMissionsError", err));
  };
  var onDispatch = {
    onExit: onDispatch_onExit,
    onPreloaderReady: ready,
    onFailed: onDispatch_onFailed,
    onJourneyReady: ready
  };
  return React.createElement("div", {
              style: match$1[0]
            }, React.createElement(CobraContainer$LiteracyplanetClientFlags.make, {
                  view: "jwt",
                  props: xprops,
                  onDispatch: onDispatch
                }));
}

var make = StoryverseIntro;

export {
  xprops ,
  make ,
}
/* react Not a pure module */
